import { render } from "./Activity-Message-not-heard.vue?vue&type=template&id=5e2d0c27"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__